var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "subscribe flex" }, [
    _c("div", { staticClass: "form-field" }, [
      _c("label", { attrs: { for: "subscribe" } }, [
        _vm._v("Exclusive offers and weekly specials")
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.email,
            expression: "email"
          }
        ],
        attrs: { type: "email", placeholder: "Email address" },
        domProps: { value: _vm.email },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.email = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "button black",
        attrs: { disabled: _vm.isDisabled },
        on: { click: _vm.subscribe }
      },
      [_vm._v("Submit")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fbe8c8b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fbe8c8b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/modulatte-core/subscribers/Form.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7fbe8c8b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/modulatte-core/subscribers/Form.vue
// module chunks = 1